(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAsignacionDialogController', SSAsignacionDialogController);

    SSAsignacionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSAsignacion', 'SSPeriodo', 'SSUnidadReceptora', 'SSPersona', 'AlumnoUadyMatriculado', 'SSPerfil'];

    function SSAsignacionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSAsignacion, SSPeriodo, SSUnidadReceptora, SSPersona, AlumnoUadyMatriculado, SSPerfil) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssperiodos = SSPeriodo.query();
        vm.ssunidadreceptoras = SSUnidadReceptora.query();
        vm.sspersonas = SSPersona.query();
        vm.alumnouadymatriculados = AlumnoUadyMatriculado.query();
        vm.ssperfils = SSPerfil.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSAsignacion.id !== null) {
                SSAsignacion.update(vm.sSAsignacion, onSaveSuccess, onSaveError);
            } else {
                SSAsignacion.save(vm.sSAsignacion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAsignacionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.iniPrestacion = false;
        vm.datePickerOpenStatus.finPrestacion = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;
        vm.datePickerOpenStatus.fechaLiberacion = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
